import React, { useState } from "react";
import "./App.css";
import "./styles/responsive.css";
// App version: 0.1.1 - Delegation & Timeline fixes
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import MyTask from "./pages/MyTask";
import Dashboard from "./pages/Dashboard";
import Summarize from "./pages/Summarize";
import FlipCard from "./components/FlipCard";
import Task from "./pages/Task";
import Groups from "./pages/Groups";
import Project from "./pages/Project";
import CreateUser from "./pages/CreateUser";
import MyProfile from "./pages/MyProfile";
import GoogleCallback from "./components/GoogleCallback";
import YesNo from "./pages/YesNo";
import NotFound404 from "./pages/NotFound404";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import getApiUrl from "./utils/api";
import RolePermission from "./pages/RolePermission";
import AdminDashboard from "./pages/AdminDashboard";
import ErrorBoundary from "./components/ErrorBoundary";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Auth check using /me endpoint and cookie
const isAuthenticated = async () => {
  try {
    const res = await fetch(getApiUrl("api/auth/me"), {
      credentials: "include",
    });
    if (!res.ok) return false;
    const data = await res.json();
    return !!data.user;
  } catch {
    return false;
  }
};

// Wrapper for protected routes
function PrivateRoute({ children }) {
  const location = useLocation();
  const [auth, setAuth] = React.useState(null);
  React.useEffect(() => {
    isAuthenticated().then(setAuth);
  }, []);

  if (auth === null) return null; // or a loading spinner
  return auth ? (
    children
  ) : (
    <Navigate to="/" state={{ from: location }} replace />
  );
}

function App() {
  const [, setLoggedIn] = useState(false);

  return (
    <ErrorBoundary>
      <Router>
        <Routes>
          <Route path="/" element={<LoginWrapper setLoggedIn={setLoggedIn} />} />
          <Route
            path="/google-callback"
            element={<GoogleCallback setLoggedIn={setLoggedIn} />}
          />
          <Route
            path="/mytask"
            element={
              <PrivateRoute>
                <MyTask />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/summarize"
            element={
              <PrivateRoute>
                <Summarize />
              </PrivateRoute>
            }
          />
          <Route
            path="/roles"
            element={
              <PrivateRoute>
                <RolePermission />
              </PrivateRoute>
            }
          />
          <Route
            path="/task"
            element={
              <PrivateRoute>
                <Task />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <PrivateRoute>
                <AdminDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/groups"
            element={
              <PrivateRoute>
                <Groups />
              </PrivateRoute>
            }
          />
          <Route
            path="/project"
            element={
              <PrivateRoute>
                <Project />
              </PrivateRoute>
            }
          />
          <Route
            path="/yesno"
            element={
              <PrivateRoute>
                <YesNo />
              </PrivateRoute>
            }
          />
          <Route path="/create-user" element={<CreateUser />} />
          <Route path="/myprofile" element={<MyProfile />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="*" element={<NotFound404 />} />
        </Routes>
      </Router>
      <ToastContainer />
    </ErrorBoundary>
  );
}

function LoginWrapper({ setLoggedIn }) {
  const location = useLocation();
  const from = location.state?.from?.pathname || "/mytask";

  const handleLogin = () => {
    setLoggedIn(true);
    window.location.replace(from);
  };

  React.useEffect(() => {
    // If already authenticated (cookie present), skip login and go to landing
    isAuthenticated().then((ok) => {
      if (ok) {
        window.location.replace(from);
      }
    });
  }, [from]);

  return <FlipCard onLogin={handleLogin} />;
}

export default App;
